import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { Position } from '@/types';
import { useUpdatePositionMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface UpdatePositionProps extends DialogProps {
  position: Position;
  onClose(): void;
}

const UpdatePosition: React.FC<UpdatePositionProps> = ({ position, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [updatePosition, updatePositionResponse] = useUpdatePositionMutation();

  const { values, errors, touched, handleSubmit, handleChange } = useFormik<Position>({
    initialValues: position ?? {
      name: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(position, { resetForm }) {
      try {
        await updatePosition(position).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Редактировать должность</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={updatePositionResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            disabled={updatePositionResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" disabled={updatePositionResponse.isLoading}>
            Редактировать
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default UpdatePosition;
